import { render, staticRenderFns } from "./SkemaScada.vue?vue&type=template&id=8851a3d0&"
import script from "./SkemaScada.vue?vue&type=script&lang=js&"
export * from "./SkemaScada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports